import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'

import { Organization } from 'js/models'
import { FormFeedback } from 'js/services/api'
import { partialUpdateOrganization } from 'js/services/organization'
import { getDataFromForm } from 'js/utils/helpers'

export default function EditOrganizationModal(props: {
  organization: Organization
  show: boolean
  handleClose: () => void
  setOrganization: (organization: Organization) => void
}): React.ReactElement {
  const { organization, show, handleClose, setOrganization } = props
  const [errors, setErrors] = useState({} as FormFeedback<Organization>)

  const resetFormFeedback = (): void =>
    setErrors({} as FormFeedback<Organization>)

  const onSave = (e: React.FormEvent): void => {
    e.preventDefault()
    resetFormFeedback()

    const data = getDataFromForm(
      e.target,
      ['name', 'phoneNumber', 'addressLine1', 'addressLine2', 'addressLine3'],
      'organizationForm_'
    )

    partialUpdateOrganization(organization.id, data as Organization)
      .then(r => {
        handleClose()
        setOrganization(r as Organization)
      })
      .catch(e => setErrors(e.formErrors))
    // Lesser TODO: Show saved successfull message
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop='static'
      size='lg'
      scrollable
    >
      <Form onSubmit={onSave}>
        <Modal.Header>
          <Modal.Title>Edit Organization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group controlId='organizationForm_name' className='form-group'>
                <Form.Label>Organization Name</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Name'
                  defaultValue={organization.name}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId='organizationForm_phoneNumber' className='form-group'>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Phone'
                  defaultValue={organization.phoneNumber}
                  isInvalid={!!errors.phoneNumber}
                  maxLength={12}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.phoneNumber}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Label>Physical Address</Form.Label>
              <Form.Group controlId='organizationForm_addressLine1' className='form-group'>
                <Form.Label hidden>Address Line 1</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Line 1'
                  defaultValue={organization.addressLine1 || undefined}
                  isInvalid={!!errors.addressLine1}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.addressLine1}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId='organizationForm_addressLine2' className='form-group'>
                <Form.Label hidden>Address Line 2</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Line 2'
                  defaultValue={organization.addressLine2 || undefined}
                  isInvalid={!!errors.addressLine2}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.addressLine2}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId='organizationForm_addressLine3' className='form-group'>
                <Form.Label>Country</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Country'
                  defaultValue={organization.addressLine3 || undefined}
                  isInvalid={!!errors.addressLine3}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.addressLine3}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='danger'
            onClick={(): void => {
              resetFormFeedback()
              handleClose()
            }}
          >
            Cancel
          </Button>
          <Button variant='primary' type='submit'>
            Save Changes
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}
